import ClickToPausePlugin from './click_to_pause'
export default ClickToPausePlugin
